import { TemplateType_Slug } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { createShallowStore, createStoreWithPersistAndSubscribe, createStoreWithSubscribe } from '@frontend/store';

export type TemplateFormState = {
  activeStep: number;
  templateId: string | undefined;
  name: string | undefined;
  locations: string[] | undefined;
  templateType: TemplateType_Slug | undefined;
  templateString: string | undefined;
};
type TemplateFormActions = {
  setTemplateFormStateInStore: (template: TemplateFormState) => void;
};
type TemplateFormStore = TemplateFormState & TemplateFormActions;

// Save template form data in Store to persist between landingPage and TemplateForm page navigation.
export const useTemplateFormStore = createStoreWithSubscribe<TemplateFormStore>(
  (set) => {
    return {
      activeStep: 1,
      templateId: undefined,
      name: undefined,
      locations: undefined,
      templateType: undefined,
      templateString: undefined,

      setTemplateFormStateInStore: (template) => {
        set({
          activeStep: template.activeStep,
          templateId: template.templateId,
          name: template.name,
          locations: template.locations,
          templateType: template.templateType,
          templateString: template.templateString,
        });
      },
    };
  },
  { name: 'TemplateFormState' }
);

export const useTemplateFormShallowStore = createShallowStore(useTemplateFormStore);

type LandingPageStatus = 'new' | 'existing' | 'deleted';

type ReviewLandingPageState = {
  reviewLandingPageId: string | undefined;
  status: LandingPageStatus;
};
type ReviewLandingPageActions = {
  setReviewLandingPageDataInStore: (reviewLandingPageId: string | undefined, status?: LandingPageStatus) => void;
  resetReviewLandingPageStatus: () => void;
};
type ReviewLandingPageStore = ReviewLandingPageState & ReviewLandingPageActions;

export const useReviewLandingPageStore = createStoreWithPersistAndSubscribe<ReviewLandingPageStore>(
  (set) => {
    return {
      reviewLandingPageId: undefined,
      status: 'existing',

      setReviewLandingPageDataInStore: (reviewLandingPageId, status = 'existing') => {
        set({ reviewLandingPageId, status });
      },
      resetReviewLandingPageStatus: () => {
        set({ status: 'existing' });
      },
    };
  },
  { name: 'ReviewLandingPageStorage' },
  { name: 'ReviewLandingPageStore', trace: true }
);
